export default function Logo({ onClick, style }: { onClick?: any; style?: any }) {
  return (
    <svg
      viewBox='0 258.21 822.38 282.969'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      style={style}
      onClick={onClick}
    >
      <defs>
        <clipPath id='0cb52a4a9e'>
          <path
            d='M 107.875 276.191406 L 141.011719 276.191406 L 141.011719 290.144531 L 107.875 290.144531 Z M 107.875 276.191406 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='ca5c748cab'>
          <path
            d='M 98.230469 522.644531 L 127.878906 522.644531 L 127.878906 527.003906 L 98.230469 527.003906 Z M 98.230469 522.644531 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='f8f5e73ffa'>
          <path
            d='M 0 268.796875 L 272 268.796875 L 272 540.863281 L 0 540.863281 Z M 0 268.796875 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='dadb029edc'>
          <path
            d='M 23.496094 290.03125 L 252.832031 290.03125 L 252.832031 519.371094 L 23.496094 519.371094 Z M 23.496094 290.03125 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='19a1e254b7'>
          <path
            d='M 57.816406 298.265625 L 112.753906 298.265625 L 112.753906 320.9375 L 57.816406 320.9375 Z M 57.816406 298.265625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='e173ce1686'>
          <path
            d='M 66.839844 290.03125 L 137.46875 290.03125 L 137.46875 321.425781 L 66.839844 321.425781 Z M 66.839844 290.03125 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='432132f950'>
          <path
            d='M 45.234375 479.960938 L 113.25 479.960938 L 113.25 502.632812 L 45.234375 502.632812 Z M 45.234375 479.960938 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='2b5830a2f5'>
          <path
            d='M 78.789062 493.054688 L 135.46875 493.054688 L 135.46875 524.445312 L 78.789062 524.445312 Z M 78.789062 493.054688 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='897e44cb39'>
          <path d='M 149 419 L 244 419 L 244 514 L 149 514 Z M 149 419 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='219630526b'>
          <path
            d='M 202.445312 419.5625 L 243.855469 469.050781 L 191.023438 513.257812 L 149.613281 463.773438 Z M 202.445312 419.5625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='95028a40a8'>
          <path d='M 145 433 L 235 433 L 235 523 L 145 523 Z M 145 433 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='1561b51c78'>
          <path
            d='M 197.75 433.527344 L 234.523438 485.488281 L 182.5625 522.257812 L 145.789062 470.296875 Z M 197.75 433.527344 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='6647bdac93'>
          <path
            d='M 92.238281 487.890625 L 101.828125 487.890625 L 101.828125 498.355469 L 92.238281 498.355469 Z M 92.238281 487.890625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='81c7bfb065'>
          <path
            d='M 45.234375 309.703125 L 100.171875 309.703125 L 100.171875 332.375 L 45.234375 332.375 Z M 45.234375 309.703125 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='f8d48d2360'>
          <path d='M 164 500 L 198 500 L 198 522 L 164 522 Z M 164 500 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='0e1dfb6e39'>
          <path
            d='M 164.289062 500.65625 L 197.421875 500.773438 L 197.351562 521.699219 L 164.214844 521.585938 Z M 164.289062 500.65625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='a9069451d9'>
          <path
            d='M 135.902344 495.773438 L 142.007812 495.773438 L 142.007812 521.933594 L 135.902344 521.933594 Z M 135.902344 495.773438 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='e5e27e5932'>
          <path
            d='M 135.902344 502.839844 L 142.007812 502.839844 L 142.007812 529 L 135.902344 529 Z M 135.902344 502.839844 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='c28f64f6c5'>
          <path
            d='M 137.707031 289.628906 L 142.066406 289.628906 L 142.066406 315.789062 L 137.707031 315.789062 Z M 137.707031 289.628906 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='4d891c5b6b'>
          <path d='M 195 404 L 264 404 L 264 474 L 195 474 Z M 195 404 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='b497938636'>
          <path
            d='M 229.585938 404.703125 L 263.5 438.613281 L 228.972656 473.144531 L 195.058594 439.230469 Z M 229.585938 404.703125 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='47ec6ba7c7'>
          <path d='M 164 492 L 198 492 L 198 514 L 164 514 Z M 164 492 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='083409c8d6'>
          <path
            d='M 164.355469 492.855469 L 197.492188 492.972656 L 197.417969 513.898438 L 164.285156 513.785156 Z M 164.355469 492.855469 '
            clipRule='nonzero'
          />
        </clipPath>
      </defs>
      <rect x='-81' width='972' fill='none' y='-80.999999' height='971.999992' fillOpacity='1' />
      <rect x='-81' width='892.415' fill='none' y='232.919' height='329.129' fillOpacity='1' />
      <g clipPath='url(#0cb52a4a9e)'>
        <g transform='matrix(0.863781, 0, 0, 0.862209, 78.824443, 256.072714)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#ca5c748cab)'>
        <g transform='matrix(0, -0.222093, 0.222956, 0, 97.410526, 535.801457)'>
          <image
            x='0'
            y='0'
            width='373'
            height='176'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXUAAACwCAIAAAB/zWksAAAABmJLR0QA/wD/AP+gvaeTAAACRklEQVR4nO3UQQ3AIADAQEAVyrHHVDQky52Cvjr3uQMgsF4HAL/lL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWofK1wA01UDs33AAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#f8f5e73ffa)'>
        <path
          fill='#1155cc'
          d='M 271.792969 404.691406 C 271.792969 406.917969 271.738281 409.140625 271.628906 411.359375 C 271.519531 413.582031 271.355469 415.800781 271.140625 418.011719 C 270.921875 420.226562 270.648438 422.433594 270.324219 424.632812 C 269.996094 426.832031 269.617188 429.023438 269.183594 431.203125 C 268.75 433.386719 268.261719 435.554688 267.722656 437.710938 C 267.179688 439.871094 266.585938 442.011719 265.941406 444.140625 C 265.296875 446.269531 264.597656 448.378906 263.851562 450.476562 C 263.101562 452.570312 262.300781 454.644531 261.449219 456.699219 C 260.597656 458.753906 259.695312 460.785156 258.746094 462.796875 C 257.796875 464.804688 256.796875 466.792969 255.746094 468.753906 C 254.699219 470.714844 253.601562 472.648438 252.460938 474.558594 C 251.316406 476.464844 250.125 478.34375 248.890625 480.191406 C 247.65625 482.042969 246.375 483.859375 245.050781 485.644531 C 243.726562 487.433594 242.359375 489.183594 240.945312 490.90625 C 239.535156 492.625 238.082031 494.308594 236.589844 495.957031 C 235.097656 497.601562 233.5625 499.214844 231.992188 500.785156 C 230.417969 502.359375 228.808594 503.890625 227.160156 505.386719 C 225.511719 506.878906 223.828125 508.332031 222.109375 509.742188 C 220.390625 511.152344 218.636719 512.519531 216.851562 513.847656 C 215.0625 515.171875 213.246094 516.449219 211.398438 517.6875 C 209.546875 518.921875 207.667969 520.113281 205.761719 521.253906 C 203.855469 522.398438 201.917969 523.496094 199.957031 524.542969 C 197.996094 525.589844 196.011719 526.589844 194 527.542969 C 191.988281 528.492188 189.957031 529.394531 187.902344 530.246094 C 185.847656 531.097656 183.773438 531.894531 181.679688 532.644531 C 179.585938 533.394531 177.472656 534.09375 175.34375 534.738281 C 173.21875 535.382812 171.074219 535.976562 168.917969 536.515625 C 166.757812 537.058594 164.589844 537.542969 162.410156 537.976562 C 160.226562 538.410156 158.035156 538.792969 155.835938 539.117188 C 153.636719 539.445312 151.429688 539.71875 149.21875 539.933594 C 147.003906 540.152344 144.785156 540.316406 142.566406 540.425781 C 140.34375 540.535156 138.121094 540.589844 135.898438 540.589844 C 133.671875 540.589844 131.449219 540.535156 129.230469 540.425781 C 127.007812 540.316406 124.789062 540.152344 122.578125 539.933594 C 120.363281 539.71875 118.15625 539.445312 115.957031 539.117188 C 113.757812 538.792969 111.566406 538.410156 109.382812 537.976562 C 107.203125 537.542969 105.035156 537.058594 102.875 536.515625 C 100.71875 535.976562 98.578125 535.382812 96.449219 534.738281 C 94.320312 534.09375 92.207031 533.394531 90.113281 532.644531 C 88.019531 531.894531 85.945312 531.097656 83.890625 530.246094 C 81.835938 529.394531 79.804688 528.492188 77.792969 527.542969 C 75.78125 526.589844 73.796875 525.589844 71.835938 524.542969 C 69.875 523.496094 67.941406 522.398438 66.03125 521.253906 C 64.125 520.113281 62.246094 518.921875 60.398438 517.6875 C 58.546875 516.449219 56.730469 515.171875 54.941406 513.847656 C 53.15625 512.519531 51.402344 511.152344 49.683594 509.742188 C 47.964844 508.332031 46.28125 506.878906 44.632812 505.386719 C 42.984375 503.890625 41.375 502.359375 39.804688 500.785156 C 38.230469 499.214844 36.699219 497.601562 35.203125 495.957031 C 33.710938 494.308594 32.257812 492.625 30.847656 490.90625 C 29.4375 489.183594 28.066406 487.433594 26.742188 485.644531 C 25.417969 483.859375 24.136719 482.042969 22.902344 480.191406 C 21.667969 478.34375 20.476562 476.464844 19.335938 474.558594 C 18.191406 472.648438 17.09375 470.714844 16.046875 468.753906 C 15 466.792969 14 464.804688 13.046875 462.796875 C 12.097656 460.785156 11.195312 458.753906 10.34375 456.699219 C 9.492188 454.644531 8.691406 452.570312 7.945312 450.476562 C 7.195312 448.378906 6.496094 446.269531 5.851562 444.140625 C 5.207031 442.011719 4.613281 439.871094 4.074219 437.710938 C 3.53125 435.554688 3.046875 433.386719 2.609375 431.203125 C 2.175781 429.023438 1.796875 426.832031 1.472656 424.632812 C 1.144531 422.433594 0.871094 420.226562 0.65625 418.011719 C 0.4375 415.800781 0.273438 413.582031 0.164062 411.359375 C 0.0546875 409.140625 0 406.917969 0 404.691406 C 0 402.46875 0.0546875 400.246094 0.164062 398.023438 C 0.273438 395.804688 0.4375 393.585938 0.65625 391.371094 C 0.871094 389.160156 1.144531 386.953125 1.472656 384.753906 C 1.796875 382.550781 2.175781 380.363281 2.609375 378.179688 C 3.046875 376 3.53125 373.828125 4.074219 371.671875 C 4.613281 369.515625 5.207031 367.371094 5.851562 365.242188 C 6.496094 363.117188 7.195312 361.003906 7.945312 358.910156 C 8.691406 356.816406 9.492188 354.742188 10.34375 352.6875 C 11.195312 350.632812 12.097656 348.601562 13.046875 346.589844 C 14 344.578125 15 342.59375 16.046875 340.632812 C 17.09375 338.667969 18.191406 336.734375 19.335938 334.828125 C 20.476562 332.921875 21.667969 331.042969 22.902344 329.191406 C 24.136719 327.34375 25.417969 325.523438 26.742188 323.738281 C 28.066406 321.953125 29.4375 320.199219 30.847656 318.480469 C 32.257812 316.761719 33.710938 315.078125 35.203125 313.429688 C 36.699219 311.78125 38.230469 310.171875 39.804688 308.597656 C 41.375 307.027344 42.984375 305.492188 44.632812 304 C 46.28125 302.507812 47.964844 301.054688 49.683594 299.644531 C 51.402344 298.230469 53.15625 296.863281 54.941406 295.539062 C 56.730469 294.214844 58.546875 292.933594 60.398438 291.699219 C 62.246094 290.460938 64.125 289.273438 66.03125 288.128906 C 67.941406 286.988281 69.875 285.890625 71.835938 284.84375 C 73.796875 283.792969 75.78125 282.792969 77.792969 281.84375 C 79.804688 280.890625 81.835938 279.992188 83.890625 279.140625 C 85.945312 278.289062 88.019531 277.488281 90.113281 276.738281 C 92.207031 275.992188 94.320312 275.292969 96.449219 274.648438 C 98.578125 274 100.71875 273.410156 102.875 272.867188 C 105.035156 272.328125 107.203125 271.839844 109.382812 271.40625 C 111.566406 270.972656 113.757812 270.59375 115.957031 270.265625 C 118.15625 269.941406 120.363281 269.667969 122.578125 269.449219 C 124.789062 269.230469 127.007812 269.070312 129.230469 268.960938 C 131.449219 268.851562 133.671875 268.796875 135.898438 268.796875 C 138.121094 268.796875 140.34375 268.851562 142.566406 268.960938 C 144.785156 269.070312 147.003906 269.230469 149.21875 269.449219 C 151.429688 269.667969 153.636719 269.941406 155.835938 270.265625 C 158.035156 270.59375 160.226562 270.972656 162.410156 271.40625 C 164.589844 271.839844 166.757812 272.328125 168.917969 272.867188 C 171.074219 273.410156 173.21875 274 175.34375 274.648438 C 177.472656 275.292969 179.585938 275.992188 181.679688 276.738281 C 183.773438 277.488281 185.847656 278.289062 187.902344 279.140625 C 189.957031 279.992188 191.988281 280.890625 194 281.84375 C 196.011719 282.792969 197.996094 283.792969 199.957031 284.84375 C 201.917969 285.890625 203.855469 286.988281 205.761719 288.128906 C 207.667969 289.273438 209.546875 290.460938 211.398438 291.699219 C 213.246094 292.933594 215.0625 294.214844 216.851562 295.539062 C 218.636719 296.863281 220.390625 298.230469 222.109375 299.644531 C 223.828125 301.054688 225.511719 302.507812 227.160156 304 C 228.808594 305.492188 230.417969 307.027344 231.992188 308.597656 C 233.5625 310.171875 235.097656 311.78125 236.589844 313.429688 C 238.082031 315.078125 239.535156 316.761719 240.945312 318.480469 C 242.359375 320.199219 243.726562 321.953125 245.050781 323.738281 C 246.375 325.523438 247.65625 327.34375 248.890625 329.191406 C 250.125 331.042969 251.316406 332.921875 252.460938 334.828125 C 253.601562 336.734375 254.699219 338.667969 255.746094 340.632812 C 256.796875 342.59375 257.796875 344.578125 258.746094 346.589844 C 259.695312 348.601562 260.597656 350.632812 261.449219 352.6875 C 262.300781 354.742188 263.101562 356.816406 263.851562 358.910156 C 264.597656 361.003906 265.296875 363.117188 265.941406 365.242188 C 266.585938 367.371094 267.179688 369.515625 267.722656 371.671875 C 268.261719 373.828125 268.75 376 269.183594 378.179688 C 269.617188 380.363281 269.996094 382.550781 270.324219 384.753906 C 270.648438 386.953125 270.921875 389.160156 271.140625 391.371094 C 271.355469 393.585938 271.519531 395.804688 271.628906 398.023438 C 271.738281 400.246094 271.792969 402.46875 271.792969 404.691406 Z M 271.792969 404.691406 '
          fillOpacity='1'
          fillRule='nonzero'
        />
      </g>
      <g clipPath='url(#dadb029edc)'>
        <path
          fill='#ffffff'
          d='M 138.15625 290.03125 C 74.804688 290.03125 23.496094 341.34375 23.496094 404.695312 C 23.496094 468.046875 74.804688 519.355469 138.15625 519.355469 C 201.507812 519.355469 252.820312 468.046875 252.820312 404.695312 C 252.820312 341.34375 201.507812 290.03125 138.15625 290.03125 Z M 138.15625 496.425781 C 87.476562 496.425781 46.425781 455.375 46.425781 404.695312 C 46.425781 354.011719 87.476562 312.964844 138.15625 312.964844 C 188.835938 312.964844 229.886719 354.011719 229.886719 404.695312 C 229.886719 455.375 188.835938 496.425781 138.15625 496.425781 Z M 138.15625 496.425781 '
          fillOpacity='1'
          fillRule='nonzero'
        />
      </g>
      <path
        strokeLinecap='butt'
        transform='matrix(0.8720069527626038, 0, 0, 0.8720069527626038, 43.53968048095703, 393.3619995117187)'
        fill='none'
        strokeLinejoin='miter'
        d='M -0.000708721 13.0013 L 193.08383 13.0013 '
        stroke='#ffffff'
        strokeWidth='26'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <g clipPath='url(#19a1e254b7)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 11.492563, 265.0111)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#e173ce1686)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 11.492563, 259.163472)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#432132f950)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, -1.090686, 446.706202)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#2b5830a2f5)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 32.462375, 459.798033)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <path
        strokeLinecap='butt'
        transform='matrix(-0.008904950693249702, 0.8719620108604431, -0.8719620108604431, -0.008904950693249702, 138.05307006835935, 289.7446899414062)'
        fill='none'
        strokeLinejoin='miter'
        d='M -0.0000391164 12.998644 L 263.222022 12.998381 '
        stroke='#ffffff'
        strokeWidth='26'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <g clipPath='url(#897e44cb39)'>
        <g clipPath='url(#219630526b)'>
          <g transform='matrix(1.304009, 1.558315, -1.555408, 1.301577, 208.932252, 313.445359)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#95028a40a8)'>
        <g clipPath='url(#1561b51c78)'>
          <g transform='matrix(1.254563, 1.77278, -1.775496, 1.256486, 235.136593, 305.659025)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <path
        strokeLinecap='butt'
        transform='matrix(-0.002767970087006688, 0.8720029592514038, -0.8720029592514038, -0.002767970087006688, 165.07907104492185, 305.83911132812494)'
        fill='none'
        strokeLinejoin='miter'
        d='M 0.00179768 13.000963 L 244.706086 12.999182 '
        stroke='#ffffff'
        strokeWidth='26'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <g clipPath='url(#6647bdac93)'>
        <g transform='matrix(0.436004, 0, 0, 0.440903, 70.461886, 477.690846)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#81c7bfb065)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, -2.785514, 276.449298)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#f8d48d2360)'>
        <g clipPath='url(#0e1dfb6e39)'>
          <g transform='matrix(1.26687, 0.00444529, -0.00443491, 1.263913, 125.304027, 471.628062)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#a9069451d9)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 89.577143, 462.516801)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#e5e27e5932)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 87.072393, 469.582616)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#c28f64f6c5)'>
        <g transform='matrix(1.423181, 0, 0, 1.420686, 91.271497, 256.372507)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#4d891c5b6b)'>
        <g clipPath='url(#b497938636)'>
          <g transform='matrix(1.186668, 1.186668, -1.191636, 1.191636, 240.630702, 301.661784)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#47ec6ba7c7)'>
        <g clipPath='url(#083409c8d6)'>
          <g transform='matrix(1.26687, 0.00444529, -0.00443491, 1.263913, 125.37343, 463.826526)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(310.976668, 429.986279)'>
          <g>
            <path d='M 49.53125 -51.890625 L 49.53125 0 L 36.890625 0 L 36.890625 -21.359375 L 17.21875 -21.359375 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 17.21875 -51.890625 L 17.21875 -31.5625 L 36.890625 -31.5625 L 36.890625 -51.890625 Z M 49.53125 -51.890625 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(379.942184, 429.986279)'>
          <g>
            <path d='M 36.890625 -9.171875 L 17.515625 -9.171875 L 14.421875 0 L 1.1875 0 L 19.953125 -51.890625 L 34.59375 -51.890625 L 53.375 0 L 39.984375 0 Z M 33.640625 -18.921875 L 27.203125 -37.921875 L 20.84375 -18.921875 Z M 33.640625 -18.921875 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(449.351209, 429.986279)'>
          <g>
            <path d='M 2.4375 -26.015625 C 2.4375 -31.140625 3.546875 -35.707031 5.765625 -39.71875 C 7.984375 -43.738281 11.078125 -46.867188 15.046875 -49.109375 C 19.015625 -51.359375 23.507812 -52.484375 28.53125 -52.484375 C 34.695312 -52.484375 39.972656 -50.859375 44.359375 -47.609375 C 48.742188 -44.359375 51.675781 -39.921875 53.15625 -34.296875 L 39.25 -34.296875 C 38.21875 -36.460938 36.753906 -38.113281 34.859375 -39.25 C 32.960938 -40.382812 30.804688 -40.953125 28.390625 -40.953125 C 24.492188 -40.953125 21.335938 -39.597656 18.921875 -36.890625 C 16.503906 -34.179688 15.296875 -30.554688 15.296875 -26.015625 C 15.296875 -21.484375 16.503906 -17.863281 18.921875 -15.15625 C 21.335938 -12.445312 24.492188 -11.09375 28.390625 -11.09375 C 30.804688 -11.09375 32.960938 -11.65625 34.859375 -12.78125 C 36.753906 -13.914062 38.21875 -15.566406 39.25 -17.734375 L 53.15625 -17.734375 C 51.675781 -12.117188 48.742188 -7.695312 44.359375 -4.46875 C 39.972656 -1.238281 34.695312 0.375 28.53125 0.375 C 23.507812 0.375 19.015625 -0.742188 15.046875 -2.984375 C 11.078125 -5.234375 7.984375 -8.351562 5.765625 -12.34375 C 3.546875 -16.332031 2.4375 -20.890625 2.4375 -26.015625 Z M 2.4375 -26.015625 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(520.608133, 429.986279)'>
          <g>
            <path d='M 34.671875 0 L 17.21875 -22.921875 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 17.21875 -51.890625 L 17.21875 -29.125 L 34.515625 -51.890625 L 49.375 -51.890625 L 29.265625 -26.46875 L 50.125 0 Z M 34.671875 0 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(587.060515, 429.986279)'>
          <g>
            <path d='M 38.359375 -51.890625 L 38.359375 -41.765625 L 17.21875 -41.765625 L 17.21875 -30.828125 L 33.046875 -30.828125 L 33.046875 -21 L 17.21875 -21 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 Z M 38.359375 -51.890625 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(642.425437, 429.986279)'>
          <g>
            <path d='M 31.046875 0 L 20.25 -19.59375 L 17.21875 -19.59375 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 25.796875 -51.890625 C 29.890625 -51.890625 33.375 -51.175781 36.25 -49.75 C 39.132812 -48.320312 41.289062 -46.363281 42.71875 -43.875 C 44.15625 -41.382812 44.875 -38.613281 44.875 -35.5625 C 44.875 -32.101562 43.898438 -29.019531 41.953125 -26.3125 C 40.003906 -23.601562 37.132812 -21.679688 33.34375 -20.546875 L 45.3125 0 Z M 17.21875 -28.53125 L 25.0625 -28.53125 C 27.375 -28.53125 29.109375 -29.097656 30.265625 -30.234375 C 31.429688 -31.367188 32.015625 -32.96875 32.015625 -35.03125 C 32.015625 -37.007812 31.429688 -38.5625 30.265625 -39.6875 C 29.109375 -40.820312 27.375 -41.390625 25.0625 -41.390625 L 17.21875 -41.390625 Z M 17.21875 -28.53125 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(705.551562, 429.986279)'>
          <g>
            <path d='M 17.21875 -41.765625 L 17.21875 -31.265625 L 34.15625 -31.265625 L 34.15625 -21.515625 L 17.21875 -21.515625 L 17.21875 -10.125 L 36.375 -10.125 L 36.375 0 L 4.578125 0 L 4.578125 -51.890625 L 36.375 -51.890625 L 36.375 -41.765625 Z M 17.21875 -41.765625 ' />
          </g>
        </g>
      </g>
      <g fill='#1155cc' fillOpacity='1'>
        <g transform='translate(760.472976, 429.986279)'>
          <g>
            <path d='M 17.21875 -41.765625 L 17.21875 -31.265625 L 34.15625 -31.265625 L 34.15625 -21.515625 L 17.21875 -21.515625 L 17.21875 -10.125 L 36.375 -10.125 L 36.375 0 L 4.578125 0 L 4.578125 -51.890625 L 36.375 -51.890625 L 36.375 -41.765625 Z M 17.21875 -41.765625 ' />
          </g>
        </g>
      </g>
    </svg>
  )
}
